(function() {
    var initInjector = angular.injector(['ng']); //, 'app.data', 'app.core'

    var $http = initInjector.get('$http');
    //var oracleServices = initInjector.get('oracleServices');
    //oracleServices.getFallbackPage({url:'toto_is_testing'})
    $http.get('./php/getDomainInfo.php')
        .then(function (response){
                //{mode:'c', cId:{value:'cpoq', squash: true}} }
                console.log(response.data);
                // response.data = {args:{
                    // cId:{squash:false,value:"barber"},
                    // language:{squash:false,value:"fr"},
                    // tId:{squash:false,value:"3"}
                    // },
                    // mode:"ct"};

                // console.log('+--- Updated domain config --> ',response.data);
                var domain = response && response.data;
                var mode = domain ? domain.mode : null;
                if (mode){
                    var DOMAIN_CONFIG = domain ? domain.args : {};

                    var appName = 'app';
                    switch (mode){
                        case 'a':
                            appName='appAssociation';
                            break;

                        case 't':
                            appName='appTherapist';
                            break;

                        case 'c':
                            appName='appClinic';
                            break;

                        case 'cx':
                            appName='appClinicNoParams';
                            break;

                        case 'ct':
                            appName='appClinicTherapist';
                            break;

                        case 'l':
                            appName='appAdvisor';
                            break;

                        default:
                            appName='app';
                            DOMAIN_CONFIG = {};
                    }

                    angular.module(appName).constant('DOMAINCONFIG', DOMAIN_CONFIG);
                    angular.module(appName).constant('DOMAINMODE', mode);
                    angular.module(appName).constant('DOMAIN_UI', {'skin':domain ? domain.skin : null, 'mode':domain ? domain.template : null});
                    angular.element(document).ready(function() {
                        var visitor_id;
                        _paq.push([ function() {
                            visitor_id = this.getVisitorId();
                            angular.module(appName).constant('PIWIKUID', visitor_id);
                            console.log('piwik UID', visitor_id);
                        }]);
                        angular.bootstrap(document, [appName]);


                    });
                }else{
                    // redirect to SimplifyStack 404 pages
                    // window.location.replace('http://www.simplifystack.com/');

                    //redirect to 404
                    window.location.replace('./404.html');
                }
            }
        );
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.bootstrap.js
 ** module id = 284
 ** module chunks = 0
 **/